/*
 * bundle-cart.js
 * Keeps "Subscribe & save" bundle lines together in the cart.
 *
 * The bundle adds two lines that share a `_bundle_group` line-item property
 * (see subscribe-bundle.js): the hidden band component + the tabs subscription.
 * Removing or changing the quantity of ANY line in a group applies the same
 * change to every line in that group — so the band can never be left in the
 * cart on its own (or the tabs without the band), which would otherwise let a
 * shopper buy the bands alone at the component price.
 *
 * Implementation: wrap CartItems.updateQuantity (inherited by the drawer's
 * CartDrawerItems). Bundle lines are detected via a `data-bundle-group`
 * attribute rendered on each cart row. Non-bundle lines are untouched.
 */
(function () {
  function patch() {
    var CI = window.customElements && customElements.get('cart-items');
    if (!CI) return window.setTimeout(patch, 50);
    if (CI.prototype.__bundleCartPatched) return;

    var original = CI.prototype.updateQuantity;

    CI.prototype.updateQuantity = function (line, quantity, name, variantId) {
      var row =
        document.getElementById('CartItem-' + line) ||
        document.getElementById('CartDrawer-Item-' + line);
      var group = row && row.dataset ? row.dataset.bundleGroup : '';

      // Not a bundle line — behave exactly like stock theme.
      if (!group) return original.call(this, line, quantity, name, variantId);

      var self = this;
      var qty = parseInt(quantity, 10);
      if (isNaN(qty)) qty = 0;
      self.enableLoading(line);

      // Resolve the sibling line-item keys in this bundle group from live cart.
      fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var keys = cart.items
            .filter(function (i) {
              return i.properties && i.properties._bundle_group === group;
            })
            .map(function (i) { return i.key; });

          if (!keys.length) {
            self.disableLoading(line);
            return original.call(self, line, quantity, name, variantId);
          }
          self.updateBundleGroup(keys, qty, line);
        })
        .catch(function () {
          // On failure, fall back to the normal single-line behaviour.
          self.disableLoading(line);
          original.call(self, line, quantity, name, variantId);
        });
    };

    CI.prototype.updateBundleGroup = function (keys, quantity, line) {
      var self = this;
      var updates = {};
      keys.forEach(function (k) { updates[k] = quantity; });
      var sections = self.getSectionsToRender().map(function (s) { return s.section; });

      fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          updates: updates,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) { return r.text(); })
        .then(function (state) {
          var parsed = JSON.parse(state);
          var empty = parsed.item_count === 0;
          self.classList.toggle('is-empty', empty);
          var drawer = document.querySelector('cart-drawer');
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', empty);
          if (drawer) drawer.classList.toggle('is-empty', empty);

          self.getSectionsToRender().forEach(function (section) {
            var container = document.getElementById(section.id);
            if (!container) return;
            var target = container.querySelector(section.selector) || container;
            target.innerHTML = self.getSectionInnerHTML(
              parsed.sections[section.section],
              section.selector
            );
          });

          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsed });
          }
        })
        .catch(function () {
          var errors =
            document.getElementById('cart-errors') ||
            document.getElementById('CartDrawer-CartErrors');
          if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        })
        .finally(function () { self.disableLoading(line); });
    };

    CI.prototype.__bundleCartPatched = true;
  }

  patch();
})();
